const ACCOUNT_ID = 'c5d570b9-7991-407b-b54e-2093c5df1784'

// User:: (REGISTRATION_SYSTEM_USER_GROUP / registration-system-user)
// Group::1b8c0e41-69ea-4838-bc80-5b96e74f67c9::GroupMembership::.*
const REGISTRATION_API_KEY = '5e0f915d-7a03-44f0-a1eb-2485c3777ef5'

// Vault::06ec974d-3c77-4f45-91a6-8e45b7a69496::Document::$[Owner=self]
const GROUPS = ['58cd6b60-b478-4d8e-929c-d4ace16e3dfd']

const VAULT_ID = '2f61250e-dfb4-41b9-a535-43b6ce3362c6'

const RESET_TOKEN = 'c2F0LWMxNTc3ZDMwLTFkOWEtNDRhOC04NDk1LWJjODE2Y2Q2OWU0ODpnQ0ZfUUNvMWlZX0k0UGIydG5nNV96d25ZYTdPTVZSTVhHcTBOVjBDUENZ'
const RESET_FLOW_ID = 'ed5a6b02-de89-4c8b-996f-21e075a9302c'
const ACTIVATE_TOKEN = 'c2F0LTE1NWUwYTFhLWJhYTAtNDczNi05NDFlLTI5OWExMTNmNDEyYTpueXJhVVVLV0t3WmlGYVhZM05OeThaNS01UVZQbmpNSzZpRE14dFNpTnZR'
const ACTIVATE_FLOW_ID = '52e7e965-9dc6-4cbd-8b3e-276006b0f148'


 const RX_METHOD_CALL_VALUE = 'call'
 const RX_METHOD_LATER_VALUE = 'later'
 const RX_METHOD_MANUAL_VALUE = 'manual'
 const RX_METHOD_EXISTING_VALUE = 'existing'
 const RX_METHOD_PROPERTY = 'rx-method'
 const RX_DOC_ID_PROPERTY = 'rx-prescription-id'
 const RX_LABEL_PROPERTY = 'rx-prescription-label'
 const RX_DOCTORS_NAME_PROPERTY = 'rx-doctors-name'
 const RX_DOCTORS_STATE_PROPERTY = 'rx-doctors-state'
 const RX_DOCTORS_NUMBER_PROPERTY = 'rx-doctors-number'
 const RX_PATIENT_DOB_MONTH_PROPERTY = 'rx-patient-dob-month'
 const RX_PATIENT_DOB_DAY_PROPERTY = 'rx-patient-dob-day'
 const RX_PATIENT_DOB_YEAR_PROPERTY = 'rx-patient-dob-year'
 const RX_PATIENT_NAME_PROPERTY = 'rx-patient-name'
 const RX_RELEASE_PROPERTY = 'rx-release'
 const RX_OD_SPH_PROPERTY = 'rx-od-sph'
 const RX_OD_CYL_PROPERTY = 'rx-od-cyl'
 const RX_OD_AXIS_PROPERTY = 'rx-od-axis'
 const RX_OD_ADD_PROPERTY = 'rx-od-add'
 const RX_OD_SEG_HEIGHT = 'rx-od-seg-height'
 const RX_OS_SPH_PROPERTY = 'rx-os-sph'
 const RX_OS_CYL_PROPERTY = 'rx-os-cyl'
 const RX_OS_AXIS_PROPERTY = 'rx-os-axis'
 const RX_OS_ADD_PROPERTY = 'rx-os-add'
 const RX_OS_SEG_HEIGHT = 'rx-os-seg-height'
 const RX_PD_PROPERTY = 'rx-pd'
 const RX_ARCHIVE_PROPERTY = 'archived'
 const RX_PLACEHOLDER_PROPERTY = 'placeholder'
 const LENS_FLOW_POWER_PROPERTY = 'power'

 
const acceptedKeys = [
  RX_OD_SPH_PROPERTY,
  RX_OD_CYL_PROPERTY,
  RX_OD_AXIS_PROPERTY,
  RX_OD_ADD_PROPERTY,
  RX_OD_SEG_HEIGHT,
  RX_OS_SPH_PROPERTY,
  RX_OS_CYL_PROPERTY,
  RX_OS_AXIS_PROPERTY,
  RX_OS_ADD_PROPERTY,
  RX_OS_SEG_HEIGHT,
  RX_PD_PROPERTY,
  RX_LABEL_PROPERTY,
  RX_ARCHIVE_PROPERTY,
  RX_PLACEHOLDER_PROPERTY
]

const messages = {
  'USER.USERNAME_IN_USE': 'This email is associated with an existing account.',
  'AUTH.UNSUCCESSFUL': 'There was an error logging in with this email or password.'
}


 const tvClient = new TrueVaultClient({apiKey: REGISTRATION_API_KEY});

 console.log("tvclient",tvClient);

/**
 * Used to see if the user is currently logged in
 * in TrueVault
 *
 * @returns {boolean} flag if token is present
 *
 */
const hasSessionToken = () => {
  return !!Cookies.get('tvToken')
}

console.log(hasSessionToken);


function tvRegister ({username = false, password = false}) {

   // const tvClient = new TrueVaultClient({apiKey: REGISTRATION_API_KEY})

    return tvClient.createUser(username, password, null, GROUPS).then(data => {
      const token = data['access_token']

      if (!token) {
        if (data.error) {
          throw new Error(data.error)
        } else {
          throw new Error('Error creating account')
        }
      }
      Cookies.set('tvToken', token, {expires: 1})
    })
  }

function tvLogin ({username, password}) {
    return TrueVaultClient.generateAccessToken(ACCOUNT_ID, username, password).then(token => {
        Cookies.set('tvToken', token, {expires: 1})
        return Promise.resolve({token})
      })
}


function createPrescription (json = {}) {
    const token = Cookies.get('tvToken')

    const instance = new TrueVaultClient({apiKey: token})

    const filtered = Object.keys(json).reduce((obj, key) => {
      //if (~acceptedKeys.indexOf(key)) {
        obj[key] = json[key]
      //}
      return obj
    }, {})

    return instance
      .readCurrentUser()
      .then(({id}) => {
        return instance.createDocument(VAULT_ID, null, filtered, id)
      })
  }

function updatePrescription (documentId, newJson) {
    const token = Cookies.get('tvToken')

    const instance = new TrueVaultClient({apiKey: token})

    const filtered = Object.keys(newJson).reduce((obj, key) => {
      if (~acceptedKeys.indexOf(key)) {
        obj[key] = newJson[key]
      }
      return obj
    }, {})

    return instance
      .readCurrentUser()
      .then(() => {
        return instance.updateDocument(VAULT_ID, documentId, filtered)
      })
  }

  function getPrescriptions () {
    const token = Cookies.get('tvToken')

    const instance = new TrueVaultClient({apiKey: token})

    return instance
      .listDocuments(VAULT_ID, true, 1, 100)
      .then(res => {
        res.items = res.items.filter(rx => {
          return (
            !rx.document[RX_ARCHIVE_PROPERTY]
          )
        })

        res.items.length && res.items.sort((x, y) => {
          const ts1 = new Date(x['created_at']).getTime()
          const ts2 = new Date(y['created_at']).getTime()
          return ts2 - ts1
        })
      })
  }

 /****************************************/ 

//  class TruevaultApi {
//   constructor () {
//     this.Client = false
//   }

//   get () {
//     return new Promise(resolve => {
//       if (this.Client) {
//         resolve(this.Client)
//         return
//       }
//       // require(['vendors/truevault'], ({TrueVaultClient}) => {
//       //   this.Client = TrueVaultClient
//       //   resolve(this.Client)
//       // })
//       this.Client = TrueVaultClient
//     })
//   }

//   /**
//    * Allows a new user to be registered in the TrueVault platform.
//    * This should be following by a request for a Shopify Multipass
//    * and then finally a redirect to the correct post-login page.
//    *
//    * @param {object} user object holding username and password
//    * @returns {promise} holding an authentication token
//    *
//    */
//   register ({username = false, password = false}) { console.log("in Register")
//     if (!username || !password) {
//       throw new Error('Username and password are required')
//     }

//     const registrationClient = new this.Client({apiKey: REGISTRATION_API_KEY})

//     return registrationClient.createUser(username, password, null, GROUPS).then(data => {
//       const token = data['access_token']

//       if (!token) {
//         if (data.error) {
//           throw new Error(data.error)
//         } else {
//           throw new Error('Error creating account')
//         }
//       }
//       Cookies.set('tvToken', token, {expires: 1})
//       return Promise.resolve({token})
//     })
//   }

//   /**
//    * Allows an existing user to login to the TrueVault platform.
//    * This should be following by a request for a Shopify Multipass
//    * and then finally a redirect to the correct post-login page.
//    *
//    * @param {object} user object holding username and password
//    * @returns {promise} holding an authentication token
//    *
//    */
//   login ({username, password}) {
//     return this.Client
//       .generateAccessToken(ACCOUNT_ID, username, password)
//       .then(token => {
//         Cookies.set('tvToken', token, {expires: 1})
//         return Promise.resolve({token})
//       })
//   }

//   /**
//    * Triggers the email providing the user with the ability
//    * to reset their password, or set their password for the
//    * first time.
//    *
//    * @param {object} user object holding username and password
//    * @returns {promise}
//    *
//    */
//   resetPassword1 ({username, isActivation = false}) {
//     const httpBasic = isActivation
//     ? ACTIVATE_TOKEN
//     : RESET_TOKEN

//     const flowId = isActivation
//     ? ACTIVATE_FLOW_ID
//     : RESET_FLOW_ID

//     const instance = new this.Client({httpBasic})
//     return instance
//       .sendPasswordResetEmail(flowId, username)
//   }

//   /**
//    * As the second phase of the reset password flow, we
//    * forward the new password to TrueVault, using an
//    * authentication token in the URL to authenticate.
//    *
//    * @param {object} user object holding username and password
//    * @returns {promise}
//    *
//    */
//   resetPassword2 ({httpAuth, userId}, {password}) {
//     const instance = new this.Client({httpBasic: httpAuth})

//     return instance
//       .updateUserPassword(userId, password)
//   }

//   /**
//    * Creates a new document in the TrueVault platform.
//    * A document corresponds to an individual prescription.
//    *
//    * @param {object} prescription JSON object
//    * @returns {promise} holding a summary of the created document
//    *
//    */
//   createPrescription (json = {}) {
//     const token = Cookies.get('tvToken')

//     const instance = new this.Client({apiKey: token})

//     const filtered = Object.keys(json).reduce((obj, key) => {
//       if (~acceptedKeys.indexOf(key)) {
//         obj[key] = json[key]
//       }
//       return obj
//     }, {})

//     return instance
//       .readCurrentUser()
//       .then(({id}) => {
//         return instance.createDocument(VAULT_ID, null, filtered, id)
//       })
//   }

//   /**
//    * Updates a document in the TrueVault platform.
//    * A document corresponds to an individual prescription.
//    *
//    * @param {object} prescription JSON object
//    * @returns {promise} holding a summary of the created document
//    *
//    */
//   updatePrescription (documentId, newJson) {
//     const token = Cookies.get('tvToken')

//     const instance = new this.Client({apiKey: token})

//     const filtered = Object.keys(newJson).reduce((obj, key) => {
//       if (~acceptedKeys.indexOf(key)) {
//         obj[key] = newJson[key]
//       }
//       return obj
//     }, {})

//     return instance
//       .readCurrentUser()
//       .then(() => {
//         return instance.updateDocument(VAULT_ID, documentId, filtered)
//       })
//   }

//   /**
//    * Gets the prescription documents that are owned by the
//    * logged in user. Currently gets the first page of prescriptions,
//    * limited to 100. Don't return any documents that have been archived
//    * or have been inserted as placeholder documents.
//    *
//    * @returns {promise} holding an array of documents
//    *
//    */
//   getPrescriptions () {
//     const token = Cookies.get('tvToken')

//     const instance = new this.Client({apiKey: token})

//     return instance
//       .listDocuments(VAULT_ID, true, 1, 100)
//       .then(res => {
//         res.items = res.items.filter(rx => {
//           return (
//             !rx.document[RX_ARCHIVE_PROPERTY]
//           )
//         })

//         res.items.length && res.items.sort((x, y) => {
//           const ts1 = new Date(x['created_at']).getTime()
//           const ts2 = new Date(y['created_at']).getTime()
//           return ts2 - ts1
//         })

//         return Promise.resolve(res)
//       })
//   }
// }

// const tv = new TruevaultApi()
// console.log("tv",tv);

// const register = ({username, password}) => ( 
//   tv.get().then(() => tv.register({username, password}))
// )
// const login = ({username, password}) => (
//   tv.get().then(() => tv.login({username, password}))
// )
// const resetPassword1 = ({username, isActivation}) => (
//   tv.get().then(() => tv.resetPassword1({username, isActivation}))
// )
// const resetPassword2 = ({httpAuth, userId}, {password}) => (
//   tv.get().then(() => tv.resetPassword2({httpAuth, userId}, {password}))
// )
// const createPrescription = (json) => (
//   tv.get().then(() => tv.createPrescription(json))
// )
// const updatePrescription = (documentId, newJson) => (
//   tv.get().then(() => tv.updatePrescription(documentId, newJson))
// )
// const getPrescriptions = () => (
//   tv.get().then(() => tv.getPrescriptions())
// )
